import apiService from '@/services/apiService';

const actions = {
  getHomepages({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('homepage/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  getHomepage({ commit }, payload) {
    apiService.get(`homepage/${payload}`)
      .then((response) => {
        commit('getHomepage', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  orderHomepage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`homepage/${payload.id}/change-order`, payload.orderData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getArticle({ commit }) {
    apiService.get('article?is_cms=true&status=publish,highlight')
      .then((response) => {
        commit('getArticle', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postHomepage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('homepage', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putHomepage({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`homepage/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delHomepage({ commit }, payload) {
    apiService.delete(`homepage/${payload}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  },

};

export default actions;
